// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-item-container-d5p8v {
  text-align: center;
  cursor: pointer;
  padding: 16px 20px;
  border-radius: var(--large-border-radius);
  -webkit-tap-highlight-color: transparent;
}

.product-item-container-d5p8v:hover {
  background-color: var(--hover-color);
}

.product-item-container-d5p8v:active {
  background-color: var(--active-color);
}

.product-item-image-MuUgs {
  width: 52px;
  height: 52px;
  display: inline-block;
}

.product-item-name-Q5C38 {
  font-size: 16px;
  font-weight: 500;
  margin-top: 16px;
  user-select: none;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/product-item/product-item.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,yCAAyC;EACzC,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":[".container {\n  text-align: center;\n  cursor: pointer;\n  padding: 16px 20px;\n  border-radius: var(--large-border-radius);\n  -webkit-tap-highlight-color: transparent;\n}\n\n.container:hover {\n  background-color: var(--hover-color);\n}\n\n.container:active {\n  background-color: var(--active-color);\n}\n\n.image {\n  width: 52px;\n  height: 52px;\n  display: inline-block;\n}\n\n.name {\n  font-size: 16px;\n  font-weight: 500;\n  margin-top: 16px;\n  user-select: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `product-item-container-d5p8v`,
	"image": `product-item-image-MuUgs`,
	"name": `product-item-name-Q5C38`
};
export default ___CSS_LOADER_EXPORT___;
